import type { Database } from "@how/database";
import { createBrowserClient } from "@how/supabase";
import type { SupabaseClient } from "@supabase/supabase-js";
import type { AppEnv } from "./env";

export type AppSupabaseClient = SupabaseClient<Database>;

/**
 * The single browser client for an app (publishable key, implicit flow, per-origin session; see @how/supabase for why
 * not PKCE). Create it once in lib/supabase.ts.
 */
export function createAppSupabase(env: AppEnv): AppSupabaseClient {
  return createBrowserClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_PUBLISHABLE_KEY);
}
